import _ from 'lodash';
import type { ScopeMessage } from '@/tools/itemProperties/ItemScope';

export const handleAnchorClick = (func: () => void) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  e.preventDefault();
  func();
};

export const getScopeMessage = (
  scopedTo: string | undefined,
  workbookId: string,
  workbookName?: string,
): ScopeMessage => {
  if (!scopedTo) {
    return { translationString: 'SCOPE.GLOBAL' };
  }

  if (_.toLower(scopedTo) === _.toLower(workbookId)) {
    return workbookName
      ? { translationString: 'SCOPE.LOCAL_NAMED', translationParameter: { analysisName: workbookName } }
      : { translationString: 'SCOPE.LOCAL' };
  }

  return { translationString: 'SCOPE.OTHER' };
};
